/**
 * 封装全局接口请求axios函数
 */

import axios from 'axios'
// import VueRouter from 'vue-router'
import router from '@/router'
import axiosSet from './axios-interceptors'
const BASE_URL = process.env.VUE_APP_API_BASE_URL
const MyAxios = axios.create({
  timeout: 1000 * 60 * 2,
  baseURL: BASE_URL,
  withCredentials: true
})
import { Toast } from 'vant';
// 请求的方式
const METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
}

async function request (url, method, data, config) {
  // console.log(url, method, params, config,'!!!')
   Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: '加载中',
  })
  switch (method) {
    case METHOD.GET: {
      const x = (await MyAxios.get(url, { params: data, ...config })).data
      Toast.clear();
      return x
    }
    case METHOD.POST: {
      const x = (await MyAxios.post(url, data, config)).data
      Toast.clear();
      return x
    }
    case METHOD.PUT: {
      const x = (await MyAxios.put(url, data, config)).data
      Toast.clear();
      return x
    }
    case METHOD.DELETE: {
      const x = (await MyAxios.delete(url, { data: data, config })).data
      Toast.clear();
      return x
    }
    default:
      Toast.clear();
      return MyAxios.get(url, { params: data, ...config })
  }
  
}
// 参数
let options = {
  router,
  msg: Toast,
}
  // 加载请求拦截器
  axiosSet.requests.forEach(item => {
    let {onFulfilled, onRejected} = item
    if (!onFulfilled || typeof onFulfilled !== 'function') {
      onFulfilled = config => config
    }
    if (!onRejected || typeof onRejected !== 'function') {
      onRejected = error => Promise.reject(error)
    }
    MyAxios.interceptors.request.use(
      config => onFulfilled(config, options),
      error => onRejected(error, options)
    )
  })
  // 加载响应拦截器
  axiosSet.response.forEach(item => {
    let {onFulfilled, onRejected} = item
    if (!onFulfilled || typeof onFulfilled !== 'function') {
      onFulfilled = response => response
    }
    if (!onRejected || typeof onRejected !== 'function') {
      onRejected = error => Promise.reject(error)
    }
    MyAxios.interceptors.response.use(
      response => onFulfilled(response, options),
      error => onRejected(error, options)
    )
  })
// export default MyPlug
export default request
